import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'app-notif-intervention-acceptee',
  templateUrl: './notif-intervention-acceptee.component.html',
  styleUrls: ['./notif-intervention-acceptee.component.scss'],
})
export class NotifInterventionAccepteeComponent implements OnInit {

  constructor(private modalController: ModalController) { }

  ngOnInit() { }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true
    });
  }
}

